import type { ChatMessage } from '../types/chat.types';

const generateId = (): string => {
  return Date.now().toString(36) + Math.random().toString(36).substr(2);
};

export const createUserMessage = (content: string): ChatMessage => ({
  id: generateId(),
  sender: 'user',
  content,
});

export const createAgentMessage = (
  id: string,
  content: string,
  citations?: any[],
  responseId?: string | null,
  reasoningSummary?: string,
): ChatMessage => ({
  id,
  sender: 'agent',
  content,
  citations,
  responseId: responseId || undefined,
  reasoningSummary: reasoningSummary || undefined,
});

export const createAbortMessage = (id: string): ChatMessage =>
  createAgentMessage(
    id,
    'Response generation was stopped by user request.\n\nYou can ask another question or try again if needed.',
  );

export { generateId };
